import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { NavDropdown, Badge } from 'react-bootstrap';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CompareIcon from '@mui/icons-material/Compare';

import { SetConfigurationChanges } from 'store/ducks/configuration.duck';
import {
  discardAllChangesConfiguration,
  getCountNotificacionChanges,
} from 'app/crud/configuration.crud';
import { successToast, errorToast } from 'utils/toastUtils';
import { ConfirmationPopup } from 'components/ConfirmDialog';
import ViewChangesModal from 'components/modals/ViewChangesModal';
import InstallChangesModal from 'components/modals/InstallChangesModal';

const NotificationChanges = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const [showModal, setShowModal] = useState(false);
  const [showModalInstall, setShowModalInstall] = useState(false);

  const { accountID, changesConfiguration } = useSelector(
    ({ auth, configuration }) => ({
      accountID: auth.user.account_id,
      changesConfiguration: configuration.changeCount,
    }),
    shallowEqual
  );

  const clickInstallNotifications = () => {
    setShowModalInstall(true);
  };

  useEffect(() => {
    getCountNotificacionChanges()
      .then((response) => {
        dispatch(SetConfigurationChanges(response.data.count_changes));
      })
      .catch(() => {});
  }, [dispatch]);

  const discardChanges = () => {
    ConfirmationPopup({
      title: intl.formatMessage({
        id: 'GENERAL.WARNING',
      }),
      description: intl.formatMessage({
        id: 'NAVBAR.CONFIRM_DISCARD_CHANGES',
      }),
      okLabel: intl.formatMessage({
        id: 'GENERAL.OK',
      }),
      cancelLabel: intl.formatMessage({
        id: 'GENERAL.CANCEL',
      }),
      okAction: () => {
        discardAllChangesConfiguration(accountID)
          .then((response) => {
            navigate(0);
            successToast({
              body: 'NAVBAR.SUCCESS_DISCARD_CHANGES',
              intl: intl,
            });
          })
          .catch((err) => {
            errorToast({ body: err.response.data?.error, intl: intl });
          });
      },
    });
  };

  return (
    <>
      {changesConfiguration > 0 && (
        <NavDropdown
          className="d-flex-navbar"
          title={
            <div className="d-flex align-items-center justify-content-center text-primary">
              <InsertDriveFileIcon />
              <FormattedMessage id="NAVBAR.CHANGES" />
              <Badge variant="warning" className="ml-1 pb-1">
                {changesConfiguration}
              </Badge>
            </div>
          }
        >
          <NavDropdown.Item onClick={clickInstallNotifications}>
            <CloudDownloadIcon style={{ marginRight: '4px' }} />
            <FormattedMessage id="NAVBAR.INSTALL_CONFIGURATION" />
          </NavDropdown.Item>
          <NavDropdown.Item onClick={() => setShowModal(true)}>
            <CompareIcon style={{ marginRight: '4px' }} />
            <FormattedMessage id="NAVBAR.VIEW_CHANGES" />
          </NavDropdown.Item>
          <NavDropdown.Item onClick={() => discardChanges()}>
            <DeleteIcon style={{ marginRight: '4px' }} />
            <FormattedMessage id="NAVBAR.DISCARD_CHANGES" />
          </NavDropdown.Item>
        </NavDropdown>
      )}
      <ViewChangesModal
        showModal={showModal}
        onHide={() => setShowModal(false)}
      ></ViewChangesModal>
      <InstallChangesModal
        showModal={showModalInstall}
        changes={changesConfiguration}
        onHide={() => setShowModalInstall(false)}
      ></InstallChangesModal>
    </>
  );
};

export default NotificationChanges;
